import turkish from './locales/tr.json';

const loaded = Object.assign(Object.create(null), { tr: turkish });
const pending = Object.create(null);
const loaders = {
  en: () => import('./locales/en.json'),
  de: () => import('./locales/de.json'),
  ar: () => import('./locales/ar.json'),
  fr: () => import('./locales/fr.json'),
  es: () => import('./locales/es.json'),
  ru: () => import('./locales/ru.json'),
  zh: () => import('./locales/zh.json'),
};
export const getCompleteLocale = locale => loaded[locale];
export function loadCompleteLocale(locale) {
  if (loaded[locale]) return Promise.resolve(loaded[locale]);
  if (!Object.prototype.hasOwnProperty.call(loaders, locale)) return Promise.reject(new Error('Unsupported locale'));
  if (!pending[locale]) {
    pending[locale] = loaders[locale]().then(module => {
      loaded[locale] = module.default;
      delete pending[locale];
      return loaded[locale];
    }, error => {
      delete pending[locale];
      throw error;
    });
  }
  return pending[locale];
}
